<div class="padding column gap">
  <div class="column gap">
    <span class="text-md semi-bold grey-color-700">{{ 'announcements.disableModal.title' | translate }}</span>

    <span class="text-sm grey-color-700">{{ 'announcements.disableModal.text' | translate }}</span>
  </div>

  <div class="row horizontal-end gap-md">
    <button mat-button class="btn btn--secondary no-ripple" (click)="closeModal()">
      {{ 'global.close' | translate }}
    </button>

    <button appLoadingButton mat-button class="btn btn--primary" (click)="disableCurrentAnnouncement()">
      {{ 'announcements.disableModal.title' | translate }}
    </button>
  </div>
</div>
